import Util from '../Common/Util';
export default class KakaoMap {
    constructor() {
        this.gps = '';
        this.callback = null;
        this.map = null;
        this.ps = null;
        this.geocoder = null;
        this.marker = null;
        this.overlay = null;
        this.address_type = 2; // 기본값: 도로명 주소
        this.history = true;   // 최근 검색어·검색 좌표 기록 (회원 기준 — 관리자 지도 /adm/map 은 끈다)
    }
    /**
     * 지도를 띄운다.
     * @param flag OPEN, CLOSE
     * @param gps 좌표(위도,경도) 37.9349,125.2342
     * @param detail 상세주소 (1: 상세주소 필요, 0: 상세주소 필요없음)
     * @param addr 주소
     * @param opts $j.Ui.FullFrame 옵션 — PC 관리자처럼 화면 가운데 창으로 띄우려면 {panel:true},
     *             창 우상단에 닫기(×)까지 얹으려면 {panel:true, closeBtn:true}
     *             src: 지도 페이지 주소 (기본 /m/map). 관리자 화면은 '/adm/map' — /m/map 은 모바일 세션이 없으면 로그인창이 뜬다
     */
    open(gps='',detail = "0", addr='', opts = {}){
        const { src = '/m/map', ...frameOpts } = opts;
        // 패널 모드는 지도 페이지에도 알려야 한다 — 모바일 주소창 대비로 캔버스를 +80px 키우는
        // 보정이 작은 창에서는 지도 아래쪽을 잘라먹는다 (searchMap.blade 의 fit 분기)
        const fit = frameOpts.panel ? '&fit=1' : '';

        // 레이어 마크업/크기/z-index 는 $j.Ui.FullFrame 공통 (이미지편집기·접수종료 지도와 동일)
        $j.Ui.FullFrame.open(`${src}?gps=${gps}&detail=${detail}&addr=${addr}${fit}`, {
            id: G5['MAP_ID'],
            frameId: G5['MAP_IFRAME_ID'],   // 앱 GPS 갱신이 이 id 로 contentWindow.moveMap 호출 (public/js/mobile.js)
            title: '주소 검색 지도',
            ...frameOpts,
        });
    }

    /**
     * 지도를 닫는다. (지도 페이지 안의 뒤로가기에서도 호출 — parent() 가 소유 창을 찾아준다)
     */
    close(){
        $j.Ui.FullFrame.parent().close(G5['MAP_ID']);
    }

    /**
     * 지도 초기화
     * @param callback 적용눌렀을때 처리할 콜백함수
     * @param opts history:false 면 최근 검색어·검색 좌표를 읽지도 쓰지도 않는다 (회원 세션이 없는 관리자 지도)
     */
    init(gps, callback=null, opts = {}) {
        if(typeof callback == 'function' ) this.callback = callback;
        this.history = opts.history !== false;
        this.initData(gps);
        this.initPage();
        this.initHandler();
    }

    /**
     * GPS 를 초기화.
     * @param gps
     */
    initData(gps){
        this.gps = gps;
    }

    /**
     * 페이지 생성 될 때 실행
     */
    initPage(){
        const container = document.getElementById('map_canvas');
        let [p1, p2] = this.gps.split(',');
        const options = {
            center: new kakao.maps.LatLng(p1, p2),
            level: 5,
        };
        // 지도 생성
        this.map = new kakao.maps.Map(container, options);
        this.map.setCenter(options.center);
        // 장소 검색 객체 생성
        this.ps = new kakao.maps.services.Places();

        // 주소-좌표 변환 객체 생성
        this.geocoder = new kakao.maps.services.Geocoder();

        // 마커 생성
        this.marker = new kakao.maps.Marker({position: options.center, map: this.map});

        this.drawOverlay();


    }

    /**
     * 검색창, 버튼 동작 이벤트
     */
    initHandler() {
        const self = this;
        let typingTimer; // 타이머 변수

        $('#showAddressvalue').on('focus', () => {
            $('#searchContainer').show();
            const keyword = $('#showAddressvalue').val();
            $('#divAddress').val(keyword);

            setTimeout(function(){
                $('#divAddress').focus();
            }, 200);
            if (keyword) {
                self.search();  // 값이 있을 때는 자동으로 검색 실행
            } else {
                $('#listClearBtn').hide();
                self.searchRecent(); // 값이 없으면 최근 검색어 불러오기
            }
        });
        // 검색 입력창 이벤트 (디바운싱 추가)
        $('#divAddress').on('input', function () {
            clearTimeout(typingTimer); // 기존 타이머 제거
            const keyword = $(this).val();

            typingTimer = setTimeout(() => {
                if (keyword.length > 0) {
                    self.search();
                }
            }, G5['DEBOUNCE_TIME']);
        });

        // x 버튼 클릭 시 입력 초기화
        $('#listClearBtn').on('click', () => {
            self.onKeywordClose(2);
        });

        // 지도에서 x 버튼 클릭 시 입력 초기화
        $('#textclearbtn').on('click', () => {
            self.onKeywordClose(1);
        });

        // 센터에 마커 그리기
        // kakao.maps.event.addListener(self.map, 'dragend', function () {
        //     self.drawCenterMarker();
        // });

        // 클릭한 장소에 마커 그리기
        kakao.maps.event.addListener(self.map, 'click', function(mouseEvent) {

            // 클릭한 위도, 경도 정보를 가져옵니다
            var latlng = mouseEvent.latLng;

            // 마커 위치를 클릭한 위치로 옮깁니다
            self.marker.setPosition(latlng);
            self.drawOverlay();
        });

        $('#current-address-btn').on('click',(e)=>{
            e.preventDefault();
            e.stopPropagation();
            self.setCenterAddressToInput();

        });
        kakao.maps.event.addListener(self.map, 'dragend', function () {
            self.drawCenterMarker();
            self.drawOverlay();
        });
    }

    /**
     * 검색어 유무에 따라 주소 검색, 최근 검색어 목록 함수가 실행
     */
    search() {
        const keyword = $('#divAddress').val();
        if (keyword) {
            this.hideRecentList();
            this.drawKeywordCloseBtn(2);
            this.searchAddress(keyword);
        } else {
            this.searchRecent();
        }
    }

    /**
     * 검색어 입력 시 키워드 검색, 주소 검색이 자동 완성으로 나타남
     * @param keyword 검색어
     */
    searchAddress(keyword){

        const self = this;
        const keywordResults = [];
        const addressResults = [];
        // const localResults = [];
        let completeResults = 0;

        // 키워드, 주소 검색 실행됐는지 확인 후 합쳐서 그리기로 보냄
        function checkAddress() {
            completeResults++;
            if (completeResults === 2) {
                const finalResults = [...addressResults, ...keywordResults]; // 결과 합치기

                if (finalResults.length === 0) {
                    // 검색 결과 없음 안내 멘트 표시
                    $('#search_no_list').css('display', 'flex');   // flex 칸 — show() 는 block 으로 연다 (m-map.css)
                    $('.searchUl').hide();
                } else {
                    $('#search_no_list').hide();
                    $('.searchUl').show();
                    self.drawAddressList(finalResults);
                }
            }
        }

        // 키워드 검색
        this.ps.keywordSearch(keyword, (data, status) => {
            if (status === kakao.maps.services.Status.OK) {
                $.each(data, function (idx,row){
                    keywordResults.push({
                        'type': 'keyword',
                        'place_name': row.place_name,
                        'address_name': row.address_name,
                        'road_address_name': row.road_address_name || '',
                        'x': row.x,
                        'y': row.y,
                    });
                })
            }
            checkAddress();
        });

        // 주소 검색
        this.geocoder.addressSearch(keyword, (data, status) => {
            if (status === kakao.maps.services.Status.OK) {

                $.each(data, function (idx,row){
                    addressResults.push({
                        'type': 'address',
                        'place_name': '',
                        'address_name': row.address?.address_name || row.address_name || '',
                        'road_address_name': row.road_address?.address_name || '',
                        'x': row.x,
                        'y': row.y,
                    });
                })
            }
            checkAddress();
        });
    }

    /**
     * 유저의 최근 검색어 불러오기
     * @param mbNo 회원번호
     */
    searchRecent() {
        const self = this;
        if (!this.history) return;
        var adr = "/m/ajax/map/keywords";
        $.ajax({
            type: "get",
            url: adr,
            dataType: 'json',
            success: function(data) {
                // var data = JSON.parse(data); // 서버에서 받은 JSON 응답 파싱
                if (data.length > 0) {
                    $('#recentList').show();
                    $('#recent-ul').show();
                    $('#no_list').hide();
                    self.drawRecentList(data);
                }  else {
                    $('#recentList').show();
                    $('#recent-ul').hide();
                    $('#no_list').show();
                }
            },
        });
    }

    /**
     * 리스트 업데이트 함수
     * @param id ul의 id값 ( 최근 검색어 : recentKeywordList, 자동완성 리스트 : autocompleteList )
     * @param data 검색 목록
     */
    drawAddressList(data) {
        $('#search_no_list').hide();
        const self = this;
        let html ='';
        const keyword = $('#divAddress').val();

        $('#searchList .searchAddr').remove();

        data.forEach((item) => {
            // 장소명은 카카오 등록 업체명, keyword 는 입력값이다 — 마크업으로 넣기 전에 이스케이프
            const esc = Util.escapeHtml;
            let attrs = `data-gps = "${esc(item.y)}, ${esc(item.x)}" data-address ="${esc(item.address_name)}" data-roadname = "${esc(item.road_address_name)}" data-placename = "${esc(item.place_name)}" data-keyword="${esc(keyword)}"`
            // h3 내용 결정
            let h3Content = esc(item.type === 'address' ? item.address_name : item.place_name);

            if (item.road_address_name !== '' && item.road_address_name === item.address_name) {
                html += `<li class='searchAddr'>
                <h3>${h3Content}</h3>
                <div ${attrs} onclick="$j.F.KakaoMap.addressClick(this,2)"><span>신주소</span><p>${esc(item.road_address_name)}</p></div>
                </li>`;
            } else if (item.road_address_name !== '') {
                html += `<li class='searchAddr'>
                <h3>${h3Content}</h3>
                <div ${attrs} onclick="$j.F.KakaoMap.addressClick(this,1)"><span>구주소</span><p>${esc(item.address_name)}</p></div>
                <div ${attrs} onclick="$j.F.KakaoMap.addressClick(this,2)"><span>신주소</span><p>${esc(item.road_address_name)}</p></div>
                </li>`;
            } else {
                html += `<li class='searchAddr'>
                <h3>${h3Content}</h3>
                <div ${attrs} onclick="$j.F.KakaoMap.addressClick(this,1)"><span>구주소</span><p>${esc(item.address_name)}</p></div>
                </li>`;
            }
        });
        $('#searchList .searchUl').append(html);
        $('#addrList').show();
    }

    // /**
    //  * db에 저장된 지도 검색 그리기
    //  * @param data 검색 목록
    //  */
    // drawLocalList(data){
    //     let html = '';
    //     const keyword = $('#divAddress').val().trim(); // 공백 제거
    //
    //     // 한글자 이하
    //     if (keyword.length === 1) {
    //         data.forEach((item) => {
    //             let attrs = `data-gps = "${item.gps}" data-address ="${item.place_name}" data-keyword=${item.keyword}`
    //             html += `<li class="searchAddr">
    //             <h3>★ ${item.keyword}<h3>
    //             <div ${attrs} onclick="$j.F.KakaoMap.addressClick(this, 1)"><span><p>${item.place_name}</p></div>
    //             </li>`
    //         });
    //     // 두글자 이상
    //     } else {
    //         data.forEach((item) => {
    //             let attrs = `data-gps = "${item.gps}" data-address ="${item.place_name}" data-keyword=${keyword}`
    //             html += `<li class="searchAddr">
    //             <h3>◉ ${item.keyword}<h3>
    //             <div ${attrs} onclick="$j.F.KakaoMap.addressClick(this, 1)"><span><p>${item.place_name}</p></span></div>
    //             </li>`
    //         });
    //     }
    //     $('#searchList .searchUl').append(html);
    //     $('#addrList').show();
    //
    // }
    /**
     * 최근검색어 그리기
     * @param data 검색목록
     */
    drawRecentList(data){
        // this.hideList();
        let html = '';
        data.forEach((item) => {
            html += `<li class="searchAddr" data-keyword="${Util.escapeHtml(item.keyword)}" onclick="$j.F.KakaoMap.setKeyword(this.dataset.keyword)">${Util.escapeHtml(item.keyword)}<br></li>`
        });
        $('#recentList .searchUl').html(html);
        $('#historyBtnCont').show();
        $('#addrList').show();
    }

    /**
     * 인풋에 검색값 넣기
     * @param keyword
     */
    setKeyword(keyword){
        $('#divAddress').val(keyword);
        this.search();

    }
    /**
     * 구주소 신주소, 적용 버튼, 상세주소 그리기
     */
    drawSearchBtn(){
        $('#adrSearchBtnTd').css('display', 'flex');   // flex 칸 — show() 는 block 으로 연다 (m-map.css)
        $('#detailAddress').css('display', 'flex');
    }

    /**
     * 구주소 신주소, 적용 버튼, 상세주소 사라지기
     */
    hideSearchBtn(){
        $('#adrSearchBtnTd').hide();
        $('#detailAddress').hide();
    }

    /**
     * 구주소 신주소 버튼 현재 타입
     */
    adrTypeset(){
        let roadAddr = $('#divAddress').data('roadname');
        let jibunAddr = $('#divAddress').data('address');

        // 현재 타입에 맞는 주소를 가져와서 설정
        let detailAddr = (self.address_type === 1) ? roadAddr : jibunAddr;
        self.address_type = (self.address_type === 1) ? 2 : 1;
        if (detailAddr) {
            $('#divAddress').val(detailAddr);
        }

        $("#adrTypesetBtn").val(self.address_type == 1 ? "구주소" : "신주소");
    }
    /**
     * 주소 클릭 시 data-gps 값 얻어옴
     * @param el 선택 목록
     */
    addressClick(el, address_type){
        const self = this;
        self.address_type = address_type;
        let placeName = $(el).data('placename');
        let roadAddress = $(el).data('roadname');
        let addressName = $(el).data('address');
        let keyword = $(el).data('keyword');


        let clickedAddress = $(event.target).closest('div').find('p').text().trim();

        $('#searchContainer').hide();
        self.drawSearchBtn();
        self.hideList();

        $('#textinfoshow').val(placeName);

        $('#showAddressvalue').val(clickedAddress);
        let [x, y] = $(el).data('gps').split(',');
        $('#showAddressvalue').data('gps', $(el).data('gps'));
        $('#showAddressvalue').data('roadname', roadAddress);
        $('#showAddressvalue').data('address', addressName);

        $('#textinfoshow').focus();

        self.drawKeywordCloseBtn(1);
        self.moveToAddress(x, y);

        // 검색 기록 저장
        if (self.history) {
            var adr = "/m/ajax/map/keywords";
            let sendData = {'keyword': keyword}
            $.ajax({
                type: "POST",
                url: adr,
                dataType: 'json',
                data: sendData,
            });
        }
        self.drawOverlay(2);
    }

    /**
     * 주소의 좌표로 이동
     * @param lat 위도
     * @param lng 경도
     */
    moveToAddress(lat, lng) {
        const coords = new kakao.maps.LatLng(lat, lng);
        this.marker.setPosition(coords);
        this.map.setCenter(coords);
    }

    /**
     * 화면의 x버튼 보이기
     * @param type (1 : 지도에서 눌렀을 때, 2 : 검색어 리스트에서 눌렀을 때)
     */
    drawKeywordCloseBtn(type = 1){
        if (type === 1){
            if ($('#showAddressvalue').val()){
                $('#textclearbtn').css('display', 'flex');
            } else {
                $('#textclearbtn').hide();
            }
        } else {
            if ($('#divAddress').val()) {
                $('#listClearBtn').css('display', 'flex');
            } else {
                $('#listClearBtn').hide();
            }
        }

    }

    /**
     * 지도의 중심좌표에 마커 그리기
     */
    drawCenterMarker(){
        const latlng = this.map.getCenter();
        this.marker.setPosition(latlng);
    }

    /**
     * 검색 결과 숨기기
     */
    hideList(){
        $('#addrList').hide();
        $('#searchList').find('.searchAddr').remove();
        $('#recentList').find('.searchAddr').remove();
    }

    /**
     * 최근 검색어 숨기기
     */
    hideRecentList(){
        $('#recentList').find('.searchAddr').remove();
        $('#historyBtnCont').hide();
        $('#recentList').hide();
    }

    /**
     * x버튼 눌렀을 때 동작
     * @param type (1 : 지도에서 눌렀을 때, 2 : 검색어 리스트에서 눌렀을 때)
     */
    onKeywordClose(type = 1){
        if (type === 1){
            $('#showAddressvalue').val('');
            $('#textinfoshow').val('');

            this.drawKeywordCloseBtn(type);
            this.hideSearchBtn();
        } else {
            $('#divAddress').val(''); // 입력값 초기화

            this.hideList();
            this.searchRecent();
            this.drawKeywordCloseBtn(type);
        }
    }

    /**
     *  인포윈도우 클릭 시 마커의 좌표로 현재 주소 가져오기
     */
    setCenterAddressToInput() {
        let self = this;

        var centerCoords = self.marker.getPosition(); // 지도 중심 좌표 가져오기
        let x = centerCoords.getLng();
        let y = centerCoords.getLat();


        self.searchAddrFromCoords(centerCoords, function(result, status) {
            if (status === kakao.maps.services.Status.OK) {
                let roadAddr = result[0].road_address ? result[0].road_address.address_name : null;
                let jibunAddr = result[0].address.address_name;

                let detailAddr = roadAddr ? roadAddr : jibunAddr;
                self.address_type = roadAddr ? 2 : 1;

                $('#showAddressvalue').val(detailAddr);

                $('#textinfoshow').val('');
                $('#showAddressvalue').data('gps', `${y},${x}`);
                $('#showAddressvalue').data('roadname', detailAddr);
                $('#showAddressvalue').data('address', jibunAddr);
                self.drawSearchBtn();
                self.drawKeywordCloseBtn(1);

                if (focus) {
                    const $input = $('#showAddressvalue');
                    if ($input.length) {
                        // 레이아웃 반영 뒤 포커스 → 필요 시 jQuery focus 이벤트 트리거
                        requestAnimationFrame(() => {
                            try { $input[0].focus({ preventScroll: true }); } catch (_) { $input[0].focus(); }
                            // 만약 포커스 시 검색창 열림 등의 jQuery 핸들러가 꼭 필요 없다면 아래 줄은 제거하세요.
                            setTimeout(() => $input.trigger('focus'), 0);
                        });
                    }
                }

            }
        });
    }

    /**
     * 좌표를 주소로 변환하는 함수 (행정동 주소)
     * @param coords
     * @param callback
     */
    searchAddrFromCoords(coords, callback) {
        this.geocoder.coord2Address(coords.getLng(), coords.getLat(), callback);
    }

    /**
     * 로드뷰
     * @param tar
     */
    showRoadView(tar){
        var latlng = this.map.getCenter();
        const lat = latlng.getLat();
        const lng = latlng.getLng() ;
        //http://map.daum.net/link/roadview/37.402056,127.108212
        $j.F.App.openRoadView(`${lat},${lng}`);
    }

    /**
     * 현재 위치 불러오는 함수
     */
    map_adr_to_input(el){
        if(!$j.F.App.getDeviceContext()){
            this.moveToAddress(37.0262142,127.9627204);
        }
        this.drawOverlay();
    }

    /**
     * 지도에서 뒤로가기 (지도를 닫는것임)
     */
    // mapDaumClose(){
    //     const mapDivId = G5['map_id'];
    //     parent.$(`#${mapDivId}`).remove();
    // }

    /**
     * 적용 버튼 후 동작
     */
    apply(){
        const self = this;
        let keyword = $('#showAddressvalue').val();
        if (keyword !== $('#showAddressvalue').data('roadname') && keyword !== $('#showAddressvalue').data('address')){
            Util.swalert("검색 버튼을 눌러 주소 검색 후 적용하실 수 있습니다.!!");
            return;
        }

        let gps = $('#showAddressvalue').data('gps');
        let placeName = $('#textinfoshow').val();
        let [x, y] = gps.split(',');
        if (keyword.length < 1) {
            Util.swalert("주소 검색 후 적용하실 수 있습니다.!");
            return;
        }
        if (x < 5 || y < 5) {
            Util.swalert("위 경도값을 받지 못했습니다");
            return;
        }

        // 가장 최근 검색위치 저장
        if (self.history) {
            $.ajax({
                type: "POST",
                url: '/m/ajax/map/gps',
                data: {'gps': gps},
                complete: function (data) {
                },
            });
        }

        // 콜백함수 호출
        const data = {
            'lat' : x,
            'long': y,
            'addr': keyword,
            'address_type': self.address_type,
            'place': placeName,
        };
        setTimeout(() => {
            if(self.callback) self.callback(data);
            this.close();
        }, 100);

    }
    drawOverlay(type=1) {
        let self = this;
         const $content = $(`
      <div>
        <button type="button" id="current-address-btn"
          style="display:block; font-weight: bold; font-size: 17px; padding:6px 10px;border:1px solid #3B82F6; color:#3B82F6; border-radius:4px;background:#fff; box-shadow:0 1px 5px rgba(0,0,0,.3);">
          현위치 주소 보기
        </button>
      </div>
    `);


        if (!self.overlay) {
            self.overlay = new kakao.maps.CustomOverlay({
                clickable: true,
                content: $content[0],
                xAnchor: 0.5,
                yAnchor: 2.5,
                zIndex: 3
            });
        }
        // 2) 표시/숨김 토글
        if (type === 1) {
            self.overlay.setPosition(this.marker.getPosition());
            self.overlay.setMap(this.map);
        } else {
            self.overlay.setMap(null); // 숨김
        }


    }

}
